var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7V7.5V25H25V7H0ZM1 8H24V9.28125C23.7774 9.47479 14.9085 17.1857 14.1729 17.8232C13.5269 18.3831 12.8391 18.501 12.5 18.501C12.1609 18.501 11.4731 18.3831 10.8271 17.8232C10.6417 17.6625 9.31134 16.5058 8.34961 15.6699L8.33984 15.6572L8.33789 15.6592C5.48222 13.1771 1.1662 9.42576 1 9.28125V8ZM1 10.6025C1.87369 11.3623 4.92064 14.0112 7.54102 16.2891L1 21.457V10.6025ZM24 10.6025V21.459L17.4453 16.3008C20.0643 14.0241 23.1245 11.3639 24 10.6025ZM8.30859 16.957C8.92647 17.4941 10.0314 18.4546 10.1729 18.5771C11.0269 19.3173 11.9391 19.499 12.5 19.499C13.0609 19.499 13.9731 19.3173 14.8271 18.5771C14.9675 18.4555 16.0663 17.4993 16.6768 16.9688L24 22.7324V24H1V22.7324L8.30859 16.957Z",
    fill: "url(#paint0_linear_1_426)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_426",
    x1: 12.5,
    y1: 7,
    x2: 12.5,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B91B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B91B2C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.44cd7fc1ee23956455485ff9ff25f727.svg";
export { ForwardRef as ReactComponent };